export const WIDGET_APP_SETTINGS_URL =
  'https://apps.wix.com/communities-blog-widget-app-settings';
export const BASE_BLOG_URL = 'https://social-blog.wix.com';
export const RELATIVE_API_URL = '/_api/communities-blog-node-api';
export const PLATFORMISED_API_URL = '/_api/communities-blog-node-api/v3';
